import { string } from "prop-types";

import styled from "styled-components";

import CloseButton from "../../shared/CloseButton";

const ActiveState = ({ color }) => <SCloseButton color={color} text="Cancel" />;

const SCloseButton = styled(CloseButton)`
  transform: translateY(1px);
`;

ActiveState.propTypes = { color: string };

export default ActiveState;
